module.exports = __webpack_public_path__ + "img/t.aa985cd5.jpg";